import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { getPercentDiff } from '../../../helpers/getPercentDiff'
import { IChangeComputedFieldsProps } from '../../../models/IChangeComputedFieldsProps'

import { getFixedSum } from './getFixedSum'

export const changeGrandTotalBySubtotals = ({
  field,
  data,
}: IChangeComputedFieldsProps<IRevenue>) => {
  const psSubtotalIndex = data.findIndex((el) => el.Key === 'PersonalSystemsByMarketsTotal')
  const printSubtotalIndex = data.findIndex((el) => el.Key === 'PrintByMarketsTotal')
  const suppliesSubtotalIndex = data.findIndex((el) => el.Key === 'SuppliesByMarketsTotal')
  const polySubtotalIndexes = data.findIndex((el) => el.Key === 'PolyByMarketsTotal')

  const d3Index = data.findIndex((el) => el.Key === 'Revenue3D')

  const psSubtotal = data[psSubtotalIndex]
  const printSubtotal = data[printSubtotalIndex]

  const total = getFixedSum(psSubtotal?.[field], printSubtotal?.[field])
  const foundIndex = data.findIndex((el) => el.Key === 'GrandTotal')
  data[foundIndex] = { ...data[foundIndex], [field]: total }

  const indexes = [
    psSubtotalIndex,
    polySubtotalIndexes,
    printSubtotalIndex,
    suppliesSubtotalIndex,
    d3Index,
  ]

  for (const index of indexes) {
    data[index] = {
      ...data[index],
      YoY: getPercentDiff(
        Number(data[index].CurrentYearRevenue),
        Number(data[index].PreviousYearRevenue)
      ),
      YoYNet: getPercentDiff(
        Number(data[index].CurrentYearRevenueNet),
        Number(data[index].PreviousYearRevenueNet)
      ),
    }
  }

  return data
}
